import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

import { AutomationGroup } from "../types/automation";
import { AUTOMATION_COLLECTIONS_QUERY_KEY } from "./useFetchAutomationCollections";

type UpdatePayload = {
  id: string;
  name?: string;
  groups?: AutomationGroup[];
};

const updateAutomationCollection = async ({ id, name, groups }: UpdatePayload) => {
  const data = {
    name,
    groups
  };
  if (!name) {
    delete data.name;
  }
  if (!groups) {
    delete data.groups;
  }

  const response = await axios.put(
    `${AUTOMATION_SERVICE_ADDRESS}/automation/${id}`,
    data
  );
  return response.data;
};

export default function useUpdateAutomationCollection() {
  const queryClient = useQueryClient();
  return useMutation(updateAutomationCollection, {
    onSuccess: () => {
      queryClient.invalidateQueries(AUTOMATION_COLLECTIONS_QUERY_KEY);
    }
  });
}
